<template>
  <div id="ConfigRecaptchaUse">
    <b-row class="pt-3">
      <b-col class="new-config">
        <b-form id="config-form" class="new-test-form">
          <b-form-row>
            <b-col sm="12">
              <b-form-group>
                <p-check class="p-icon p-smooth" color="info" v-model="config.useRecaptcha" :disabled="isLoading">
                  <i slot="extra" class="icon material-icons">done</i>
                  Use reCAPTCHA for recharge payments
                </p-check>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row class="submit">
            <b-col cols="12" sm="12">
              <b-button type="button" variant="primary" :disabled="isLoading" @click.prevent="save">Save</b-button>
            </b-col>
          </b-form-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { saveConfig, fetchConfig } from '@/api/webcontent/'
export default {
  name: 'ConfigRecaptchaUse',
  created () {
    fetchConfig().then((result) => {
      this.config = result
    })
  },
  methods: {
    save () {
      saveConfig(this.config).then(() => {
        this.$toastr.s('Configuration saved')
      })
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  data () {
    return {
      config: {},
      navbarItems: [
        {
          name: 'cache',
          text: 'Cache',
          icon: 'cached'
        },
        {
          name: 'recaptcha',
          text: 'Configuration',
          icon: 'settings'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/config/ConfigRecaptchaUse.vue